import { render } from "./ManagerSalesPanelTable.vue?vue&type=template&id=6355d452&scoped=true"
import script from "./ManagerSalesPanelTable.vue?vue&type=script&lang=js"
export * from "./ManagerSalesPanelTable.vue?vue&type=script&lang=js"

import "./ManagerSalesPanelTable.vue?vue&type=style&index=0&id=6355d452&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6355d452"]])

export default __exports__